import {getCachedData, setCacheData} from 'utilities';
import {NavItemData} from './types';

const NAV_ENDPOINT = '/nav';
const NAV_CACHE_TTL = 1000 * 60 * 60 * 24;
const NAV_CACHE_KEY = 'Exchange::MegaNav';

export async function getNavData(): Promise<NavItemData[]> {
  let navData: NavItemData[] | false = false;

  // eslint-disable-next-line no-process-env
  if (process.env.NODE_ENV !== 'development') {
    navData = getCachedData(NAV_CACHE_KEY, NAV_CACHE_TTL);
  }

  if (navData !== false) {
    return navData;
  }

  try {
    const response = await fetch(NAV_ENDPOINT);
    navData = await response.json();

    if (navData === false) {
      return [];
    }

    setCacheData(NAV_CACHE_KEY, navData);
    return navData;
  } catch (error) {
    return [];
  }
}
